import { useCallback, useState, useMemo } from 'react';
import {
  getImportSourceOptions,
  handleRealUsedFlag,
} from '@bingads-webui-campaign-react/asset-library-model';

export const useImportSource = ({
  logger,
  i18n,
  preference,
  realUsedFlagSuffix,
}) => {
  const [importSource, setImportSource] = useState(null);

  const importSourceOptions = useMemo(() => getImportSourceOptions(i18n), [i18n]);

  const onImportSourceFilterChange = useCallback((newImportSource) => {
    if (importSource !== newImportSource) {
      setImportSource(newImportSource);
      logger.logTrace('onImportSourceFilterChange', { importSource: newImportSource });
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [importSource, logger, preference, realUsedFlagSuffix]);

  return {
    importSource,
    importSourceOptions,
    onImportSourceFilterChange,
  };
};
